import api from '@/api'
import * as types from '../mutation-types'

// initial state
const state = {
    conversation: [],
    openChat: false
}

// getters
const getters = {
    chatData: state => state,
}

// actions
const actions = {
    getConversation({ commit }, nomor_pendaftar) {
        api.get(`/v2/public/crm/conversation/${nomor_pendaftar}`)
            .then(response => {
                let responseData = response.data
                let castedData = []
                responseData.data.forEach(element => {
                    castedData.push({
                        type: 'text',
                        author: element.role === 'pendaftar' ? 'me' : 'admin',
                        data: {
                            text: element.pesan
                        },
                        terbaca: element.terbaca
                    });
                });
                commit(types.CONVERSATION_RECEIVE, castedData.reverse())
            })
            .catch(e => {
                // FIXME: Tell our user when we got some errors
                console.log(e)
            })
    }
}

// mutations
const mutations = {
    [types.CONVERSATION_RECEIVE](state, data) {
        state.conversation = data
    },
    [types.PUSH_CONVERSATION](state, message) {
        state.conversation = [...state.conversation, ...message]
    },
    [types.TOGGLE_OPENCHAT](state, data) {
        state.openChat = data
    }
}

export default {
    state,
    getters,
    actions,
    mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/chat.js